// Tipos de acción de mensajes
export const ACTION_TYPES = [
  { value: 'information', label: 'Información' },
  { value: 'referral', label: 'Derivación' },
  { value: 'preparation', label: 'Preparación' },
  { value: 'no category', label: 'Sin categoría' },
];

// SM: system message
export const professionalSM = ({ names, surnames, specialties, isAdmin, onCreate, values }) => {
  const arr = [
    {
      label: 'Apellido',
      type: 'autocomplete',
      propName: 'surname',
      values: names,
    },
    {
      label: 'Nombre',
      type: 'autocomplete',
      propName: 'name',
      values: surnames,
    },
    {
      label: 'Especialidad',
      type: 'autocomplete',
      propName: 'specialty',
      values: specialties,
    },
    {
      label: 'Categoría',
      type: 'select',
      propName: 'actionType',
      values: ACTION_TYPES,
      required: false,
    },
    {
      label: 'Pre mensaje',
      type: 'textarea',
      propName: 'preMessage',
      values: null,
    },
    {
      label: 'Post mensaje',
      type: 'textarea',
      propName: 'postMessage',
    },
    {
      label: 'Pasar a',
      type: 'select',
      propName: 'passTo',
      values,
    },
    {
      label: 'Filtrar obra social',
      type: 'checkbox',
      propName: 'filterOS',
    },
    {
      label: 'Filtrar turnos de tarde',
      type: 'checkbox',
      propName: 'filterApps',
    },
    {
      label: 'Mostrar turnos libres',
      type: 'checkbox',
      propName: 'showFreeApps',
    },
    isAdmin && {
      label: 'Guardar gestión',
      type: 'checkbox',
      propName: 'saveGestion',
      values: null,
    },
    {
      label: 'Frenar bot',
      type: 'checkbox',
      propName: 'stopBot',
      values: null,
    },
    onCreate && {
      label: 'Crear réplica',
      type: 'checkbox',
      propName: 'reply',
    },
    {
      label: onCreate ? 'Cancelar' : 'Borrar',
      type: 'button',
      propName: 'cancel-button',
      isSuccess: false,
    },
    {
      label: onCreate ? 'Crear' : 'Guardar',
      type: 'button',
      propName: 'ok-button',
      isSuccess: true,
    },
    {
      label: 'Posterior al turno',
      type: 'select',
      propName: 'chatStateAfterTurn',
      values,
    },
    {
      label: 'Frenar bot al otorgar turno',
      type: 'checkbox',
      propName: 'stopBotAfterTurn',
    },
  ];
  return arr.filter((e) => e);
};

export const specialtySM = ({ specialties, onCreate, isAdmin, values }) => {
  const arr = [
    {
      label: 'Especialidad',
      type: 'autocomplete',
      propName: 'typeValue',
      values: specialties,
    },
    {
      label: 'Categoría',
      type: 'select',
      propName: 'actionType',
      values: ACTION_TYPES,
      required: false,
    },
    {
      label: 'Pre Mensaje',
      type: 'textarea',
      propName: 'preMessage',
      values: null,
    },
    {
      label: 'Post Mensaje',
      type: 'textarea',
      propName: 'postMessage',
    },
    {
      label: 'Pasar a',
      type: 'select',
      propName: 'passTo',
      values,
    },
    {
      label: 'Mostrar turnos libres',
      type: 'checkbox',
      propName: 'showFreeApps',
    },
    onCreate && {
      label: 'Crear réplica',
      type: 'checkbox',
      propName: 'reply',
    },
    isAdmin && {
      label: 'Guardar gestion',
      type: 'checkbox',
      propName: 'saveGestion',
      values: null,
    },
    {
      label: 'Frenar bot',
      type: 'checkbox',
      propName: 'stopBot',
      values: null,
    },
    {
      label: onCreate ? 'Cancelar' : 'Borrar',
      type: 'button',
      propName: 'cancel-button',
      isSuccess: false,
    },
    {
      label: onCreate ? 'Crear' : 'Guardar',
      type: 'button',
      propName: 'ok-button',
      isSuccess: true,
    },
    {
      label: 'Posterior al turno',
      type: 'select',
      propName: 'chatStateAfterTurn',
      values,
    },
    {
      label: 'Frenar bot al otorgar turno',
      type: 'checkbox',
      propName: 'stopBotAfterTurn',
    },
  ];

  return arr.filter((e) => e);
};

export const obraSocialSM = (names, siglas, osPlan = [], values, onCreate) => {
  const arr = [
    {
      label: 'Obra social',
      type: 'autocomplete',
      propName: 'value',
      values: names,
    },
    {
      label: 'Sigla',
      type: 'autocomplete',
      propName: 'acronym',
      values: siglas,
    },
    {
      label: 'plan',
      type: 'autocomplete',
      propName: 'osPlan',
      values: osPlan,
    },
    {
      label: 'Categoría',
      type: 'select',
      propName: 'actionType',
      values: ACTION_TYPES,
      required: false,
    },
    {
      label: 'Mensaje',
      type: 'textarea',
      propName: 'message',
      values: null,
    },
    {
      label: 'Pasar a',
      type: 'select',
      propName: 'passTo',
      values,
    },
    {
      label: 'Priorizar',
      type: 'checkbox',
      propName: 'priority',
    },
    {
      label: 'Frenar bot',
      type: 'checkbox',
      propName: 'stopBot',
      values: false,
    },
    {
      label: 'particular',
      type: 'checkbox',
      propName: 'particular',
      values: false,
    },
    {
      label: onCreate ? 'Cancelar' : 'Borrar',
      type: 'button',
      propName: 'cancel-button',
      isSuccess: false,
    },
    {
      label: onCreate ? 'Crear' : 'Guardar',
      type: 'button',
      propName: 'ok-button',
      isSuccess: true,
    },
  ];

  return arr;
};

export const institutionalSM = ({ onCreate, values, isAdmin, showFile }) => {
  const arr = [
    isAdmin && {
      label: 'ID',
      type: 'text',
      propName: 'messageId',
      values: null,
    },
    {
      label: 'Valor',
      type: 'text',
      propName: 'value',
      values: null,
    },
    {
      label: 'Categoría',
      type: 'select',
      propName: 'actionType',
      values: ACTION_TYPES,
      required: false,
    },
    {
      label: 'Mensaje',
      type: 'textarea',
      propName: 'message',
      values: null,
    },
    showFile && {
      label: 'Imagen',
      type: 'file',
      propName: 'imageURL',
    },
    {
      label: 'Pasar a',
      type: 'select',
      propName: 'passTo',
      values,
    },
    isAdmin && {
      label: 'Guardar gestion',
      type: 'checkbox',
      propName: 'saveGestion',
      values: null,
    },
    {
      label: 'Frenar bot',
      type: 'checkbox',
      propName: 'stopBot',
      values: null,
    },
    onCreate && {
      label: 'Crear réplica',
      type: 'checkbox',
      propName: 'reply',
      values: null,
    },
    isAdmin && {
      label: onCreate ? 'Cancelar' : 'Borrar',
      type: 'button',
      propName: 'cancel-button',
      isSuccess: false,
    },
    {
      label: onCreate ? 'Crear' : 'Guardar',
      type: 'button',
      propName: 'ok-button',
      isSuccess: true,
    },
  ];

  return arr.filter((e) => !!e);
};

export const customizedMessagesInputs = (onCreate, values, isAdmin) => {
  const arr = [
    isAdmin && {
      label: 'ID',
      type: 'text',
      propName: 'messageId',
      values: null,
    },
    {
      label: 'Valor',
      type: 'text',
      propName: 'value',
      values: null,
    },
    {
      label: 'Mensaje',
      type: 'textarea',
      propName: 'message',
      values: null,
    },
    {
      label: 'Pasar a',
      type: 'select',
      propName: 'passTo',
      values,
    },
    {
      label: 'Frenar bot',
      type: 'checkbox',
      propName: 'stopBot',
      values: null,
    },
    {
      label: 'Priorizar',
      type: 'checkbox',
      propName: 'priority',
    },
    isAdmin && {
      label: 'Timer',
      type: 'timePicker',
      propName: 'timer',
      values: null,
    },
    isAdmin && {
      label: onCreate ? 'Cancelar' : 'Borrar',
      type: 'button',
      propName: 'cancel-button',
      isSuccess: false,
    },
    {
      label: onCreate ? 'Crear' : 'Guardar',
      type: 'button',
      propName: 'ok-button',
      isSuccess: true,
    },
  ];

  return arr.filter((e) => !!e);
};
